window.aboutSiteHandler = function () {
  $(document).ready(function () {
    bindSiteEvents();
  });

  // Main banner - Video
  setTimeout(function () {
    $('.jsAboutUsVideoText').fadeOut(1000)
  }, 10000);

  // We Love... slider
  const bindSiteEvents = function () {
    $('.jsAboutUsSliderImageContainer').slick({
      dots: false,
      arrows: false,
      infinite: true,
      fade: true,
      speed: 1000,
      asNavFor: ' .jsAboutUsSliderNav, .jsAboutsUsSliderTextContainer',
      cssEase: 'linear'
    });
    $('.jsAboutsUsSliderTextContainer').slick({
      dots: false,
      arrows: false,
      infinite: true,
      speed: 1000,
      fade: true,
      asNavFor: '.jsAboutUsSliderImageContainer, .jsAboutUsSliderNav',
      cssEase: 'linear'
    });
    $('.jsAboutUsSliderNav').slick({
      dots: true,
      arrows: false,
      infinite: true,
      speed: 1000,
      fade: true,
      asNavFor: '.jsAboutUsSliderImageContainer, .jsAboutsUsSliderTextContainer',
      cssEase: 'linear'
    });

    $('.jsAboutUsSliderPrev').on('click', function () {
      $('.jsAboutUsSliderImageContainer').slick('slickPrev');
    });
    $('.jsAboutUsSliderNext').on('click', function () {
      $('.jsAboutUsSliderImageContainer').slick('slickNext');
    });

    // Logo slider
    const logoSlider = $('#jsLogoSlider');
    logoSlider.slick({
      variableWidth: true,
      autoplay: true,
      autoplaySpeed: 0,
      speed: 10000,
      cssEase: 'linear',
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
    });
    logoSlider.slick('slickPause');
    logoSlider.on('mouseover', function () {
      logoSlider.slick('slickPlay');
    });
    logoSlider.on('mouseleave', function () {
      logoSlider.slick('slickPause');
    });
  };
};
